// extracted by mini-css-extract-plugin
module.exports = {"textArea":"ContentEditor_textArea__2sRgU"};